import { isNumber } from "lodash";
import React, { useCallback } from "react";

import { useModifyParentTableCell } from "../../api/hooks/allHooks";
import { techDataSections } from "../../configs/TechnicalDataEnums";
import { withHotWaterDecentralTypeCleared } from "../../configs/TechnicalDataUtils";
import { TableHeader } from "../../types/all";
import { convertTabelHeadersToFormItems } from "../../utils/components";
import ItemPopUpForm, { MutateInputs } from "../ItemPopUpForm";

type EditTechDataRowFormProps = {
  activeTab: string;
  projectId: number | string;
  row?: Record<string, unknown>;
  setSelectedRow: (row?: null | Record<string, unknown>) => void;
  tableHeaders: TableHeader[];
};

const EditTechDataRowForm: React.FC<EditTechDataRowFormProps> = ({
  activeTab,
  projectId,
  row,
  setSelectedRow,
  tableHeaders,
}) => {
  const { isLoading, mutate } = useModifyParentTableCell();
  const isOpen = !!row;
  const setIsOpen = useCallback(
    (isOpen: boolean) => {
      if (isOpen) return;
      else setSelectedRow(null);
    },
    [setSelectedRow]
  );

  const rowId = row?.id;
  if (!isNumber(rowId)) return;

  const formItems = convertTabelHeadersToFormItems(tableHeaders);

  const modify = (props: MutateInputs) => {
    const data =
      activeTab === techDataSections.HOT_WATER ? withHotWaterDecentralTypeCleared(props.data) : props.data;
    mutate({ activeTab, ...props, data });
  };

  return (
    <ItemPopUpForm
      formItems={formItems}
      initialFormData={row}
      isOpen={isOpen}
      isSubmitting={isLoading}
      mutate={modify}
      projectId={projectId}
      requiredFields={[]}
      rowId={rowId}
      setIsOpen={setIsOpen}
    />
  );
};

export default EditTechDataRowForm;
